import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import MuiTable from '@mui/material/Table';

const _Table = styled(MuiTable, { shouldForwardProp: prop => prop !== 'width' }) `
  ${({ width }) => `
    min-height: 0;
    flex-direction: column;
    box-sizing: border-box;
    outline: none;
    cursor: default;
    position: relative;
    overflow: hidden;
    width: ${width}px;
    display: flex;

    *, *::before, *::after {
      box-sizing: inherit;
    }
  `}
`;
const Table = (props) => {
    return (jsx(_Table
    // @ts-ignore
    , Object.assign({ 
        // @ts-ignore
        component: "div" }, props)));
};
Table.displayName = 'Table';

export { Table as default };
//# sourceMappingURL=Table.js.map
